import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/modifiers/${id}`)
    },
    list(params) {
        return Vue.axios.get(`/modifiers`, {params})
    },
    massEdit(act, params){
        return Vue.axios.post(`/modifiers/mass-edit/${act}`, params)
    },
    listByCategory(params) {
        return Vue.axios.get(`/modifiers-by-category`, {params})
    },
    getCategoryList(params) {
        return Vue.axios.get(`/modifiers/categories`)
    },
    listGroups(params) {
        return Vue.axios.get(`/modifiers/group`, {params})
    },
    remove(id) {
        return Vue.axios.get(`/modifiers/remove/${id}`)
    },
    update(id, data) {
        return Vue.axios.post(`/modifiers/update/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updateModifiersGroupConstructor(id, data) {
        return Vue.axios.post(`/modifier-group/constructor/update/${id}`, data)
    },
    create(data) {
        return Vue.axios.post(`/modifiers/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    removeModifierGroup(id) {
        return Vue.axios.get(`/modifier-group/remove/${id}`)
    },
   
    createModifierGroup(params) {
        return Vue.axios.post(`/modifier-group/create`, params)
    },
    updateModifierGroup(params) {
        return Vue.axios.post(`/modifier-group/update`, params)
    },
    updateModifiersGroupModifier(params) {
        return Vue.axios.post(`/modifier-group/update/modifiers`, params)
    },
    toggleModifierHide(params) {
        return Vue.axios.post(`/modifier-group/update/modifiers/hide`, params)
    },
}
